import { defineMessages } from 'react-intl'

export default defineMessages({
  addVariableButton: {
    id: 'VariableInputDropdown.insertVariableButton',
    defaultMessage: 'Insert variable'
  },
  noResults: {
    id: 'VariableInputDropdown.noResults',
    defaultMessage: 'no results found.'
  }
})
